import { Button, Input, message } from "antd";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import AuthService from "../../../../services/AuthService";

const SignInPage = () => {
  const [userCredentials, setCredentials] = useState({
    email: "",
    password: "",
  });
  const { email, password } = userCredentials;

  const handleSubmit = async () => {
    const user = await AuthService.login(email, password);
    if (user) {
      history.push("/");
    }
  };
  const history = useHistory();

  const onUpdateChange = (e) => {
    const currentData = { ...userCredentials };
    currentData[e.target.name] = e.target.value;
    setCredentials(currentData);
  };
  const onSignUp = async () => {
    if (!userCredentials.email || !userCredentials.password) {
      message.warning("Please enter email id and OTP");
    } else {
      message.success("Successfully verified");
    }
  };

  return (
    <div className="right_item">
      <div className="pubheader_sec">
        <div className="pub_title">Welcome to FoodLuv</div>
        <h3 className="sub_title">Sign in to your account</h3>
        <div className="logo_sec">
          <img src="/images/login_icon.png" alt="" />
        </div>
      </div>
      <div className="w-full">
        <div className="password_sec w-full">
          <label>Email</label>
          <Input
            className="w-full"
            name="email"
            onChange={onUpdateChange}
            value={userCredentials.email}
          />
        </div>
        <div className="password_sec w-full">
          <label>Password</label>
          <Input
            className="w-full"
            type="password"
            name="password"
            onChange={onUpdateChange}
            value={userCredentials.password}
          />
        </div>
      </div>
      <div className="otp_btns">
        <Button type="primary" className="otp_signup" onClick={handleSubmit}>
          Login
        </Button>
        <Button
          type="text"
          danger
          className="otp_resend"
          onClick={() => history.push("/forgot-password")}
        >
          Forgot Password
        </Button>
      </div>
    </div>
  );
};
export default SignInPage;
